import { _ as u, b as m } from "./helpers-CA92ST8-.js";
import s, { forwardRef as M } from "react";
import h from "./useMask.js";
import v from "../../../core/dist/module/hooks/useConnectedInputRef.js";
var w = ["component", "mask", "replacement", "showMask", "separate", "track", "modify", "onMask"];
function y(a, t) {
  var e = a.component, n = a.mask, p = a.replacement, f = a.showMask, c = a.separate, k = a.track, i = a.modify, l = a.onMask, r = u(a, w), d = h({ mask: n, replacement: p, showMask: f, separate: c, track: k, modify: i, onMask: l }), o = v(d, t);
  return e ? s.createElement(e, m({ ref: o }, r)) : s.createElement("input", m({ ref: o }, r));
}
var x = M(y);
export {
  x as default
};
//# sourceMappingURL=InputMask.js.map
